<template>
  <div class="setup_step card">
    <h4>Set your pricing</h4>
    <p>
      Now it’s time to set pricing. Below you can set the price for selling the platform on it’s own and also the
      price for selling the platform plus monthly support. For example, you could offer a monthly support product
      where you also complete SEO work for the customer.
    </p>
    <edit-product-form
      :is-wizard="true"
      :product="softwareProduct"
      :support="supportAddon"
      :use-cards="true"
      @submit="setCurrentStep('ADDONS')"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EditProductForm from "../includes/EditProductForm";

export default {
  components: {
    EditProductForm,
  },
  computed: {
    ...mapGetters('productManager', [
      'softwareProduct',
      'supportAddon',
    ]),
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'setCurrentStep',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.merchant_centre_wizard {
  .setup_form {
    .setup_step {
      > h4 {
        margin-bottom: 0.5rem;
      }

      .form-control {
        margin-top: 0;
      }
    }

    .product {
      border: 1px solid #C7C4C1!important;

      &.card {
        padding: 1rem;
        border-radius: 12px;

        h3 {
          font-weight: 700;
          font-size: 24px;
          margin-bottom: 0;
        }

        p {
          color: #4E4E54;
          margin-bottom: 0.5rem;
        }

        label {
          font-weight: 500;
          font-size: 1.125rem;
        }
      }

      &.support-toggle {
        text-align: center;
        padding: 0;

        .select_type {
          padding: 1rem;
          cursor: pointer;

          .temp_radio {
            transform: translateY(-2px);
          }

          label {
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            cursor: pointer!important;
          }
        }
      }
    }
  }
}
</style>
